import analytics from '@utils/analytics';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import SwiperCore, { Keyboard, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
SwiperCore.use([Keyboard, Navigation]);
const SearchCollections = ({ exploreCollections }) => {
    const { t } = useTranslation();
    const swiperRef = useRef();
    const renderArrows = () => (React.createElement("div", { className: "products-carousel__arrows" },
        React.createElement("button", { type: "button", className: "swiper-button-prev", "aria-label": t('carousel.prevslidemessage') },
            React.createElement("i", { className: "icon--chevron-left-big", "aria-hidden": true })),
        React.createElement("button", { type: "button", className: "swiper-button-next", "aria-label": t('carousel.nextslidemessage') },
            React.createElement("i", { className: "icon--chevron-right-big", "aria-hidden": true }))));
    return (exploreCollections === null || exploreCollections === void 0 ? void 0 : exploreCollections.length) > 0 ? (React.createElement(React.Fragment, null,
        React.createElement(Swiper, { onSwiper: (swiper) => {
                swiperRef.current = swiper;
            }, className: 'collection-submenu', wrapperTag: "ul", keyboard: true, spaceBetween: 16, navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                disabledClass: 'swiper-button-disabled',
            }, slidesPerView: "auto", breakpoints: {
                768: {
                    enabled: false,
                    slidesPerView: 3,
                },
            } }, exploreCollections.map((card, i) => (React.createElement(SwiperSlide, { key: i, tag: "li", className: 'collection-submenu__item' },
            React.createElement("a", { href: card.data.btnLink, className: "collection-card", onClick: () => { var _a, _b; return analytics.collectionsSearch(((_a = card.data) === null || _a === void 0 ? void 0 : _a.title_analytics) || ((_b = card.data) === null || _b === void 0 ? void 0 : _b.title)); } },
                React.createElement("img", { className: "collection-card__background", src: card.custom.bgImage, alt: "" }),
                React.createElement("div", { className: "collection-card__inner-content" },
                    React.createElement("img", { src: card.custom.logo, alt: "" }),
                    React.createElement("h3", { className: `collection-card__title ${card.data.title_typo}` }, card.data.title),
                    React.createElement("div", { className: "collection-card__description", dangerouslySetInnerHTML: { __html: card.data.description } }),
                    React.createElement("span", { className: "button button--tertiary-inverted button--arrow-right" }, card.data.btnText))))))),
        renderArrows())) : (React.createElement(React.Fragment, null));
};
export default SearchCollections;
